export enum ScreenSize {
    EXTRA_SMALL_MOBILE_DEVICE = 360,
    SMALL_MOBILE_DEVICE = 480,
    STANDARD_MOBILE_DEVICE = 768,
    LAPTOP = 1024,
    LAPTOP_LANDSCAPE = 1200,
}
